import React from 'react';
import { useTheme } from '@material-ui/styles';
import './LoaderSpinner.scss';

type LoaderSpinnerProps = {
  isLoading: boolean;
  width?: string;
};

const LoaderSpinner: React.FC<LoaderSpinnerProps> = ({
  isLoading,
  width = '100%'
}) => {
  const theme = useTheme() as any;

  const baseColors = theme.palette.baseColors.charts['risk-analysis'];
  const colors =
    baseColors.length >= 5
      ? [baseColors[0], baseColors[2], baseColors[4]]
      : baseColors;

  return (
    <>
      {isLoading && (
        <div
          style={
            {
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignContent: 'center',
              alignItems: 'center',
              width,
              padding: '2rem',
              '--clr1': colors[0],
              '--clr3': colors[1],
              '--clr5': colors[2]
            } as React.CSSProperties
          }
        >
          <div className="container">
            <div className="spinner">
              <div className="spinner-item"></div>
              <div className="spinner-item"></div>
              <div className="spinner-item"></div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LoaderSpinner;
